import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { QueryResult } from "@/api/utils/types"
import {
  PaperBillStateResponse,
  PaperBillStateResponsePaperBillType,
} from "@/api/backofficeRest/generated/model"

export type IPaperBillType = Exclude<PaperBillStateResponsePaperBillType, null>

export interface IPaperBillState {
  paperBillType: IPaperBillType | null
  psrPaperBillEligible: boolean
  reservedPaperBillContactEmails: string[]
}

export const emptyPaperBillState = (): IPaperBillState => ({
  paperBillType: null,
  psrPaperBillEligible: false,
  reservedPaperBillContactEmails: [],
})

export interface IPaperBillService {
  getState(billingAccountId: number | null): QueryResult<IPaperBillState>
}

class PaperBillServiceClass implements IPaperBillService {
  getState(billingAccountId: number | null): QueryResult<IPaperBillState> {
    return useQuery({
      ...BackofficeRestQueries.paperBill.state(billingAccountId ?? 0),
      enabled: !!billingAccountId,
      placeholderData: emptyPaperBillState(),
      useRawResponse: true,
      parserFn: (data: PaperBillStateResponse) => {
        if (!data) return emptyPaperBillState()
        return {
          paperBillType: data.paperBillType ?? null,
          psrPaperBillEligible: data.psrPaperBillEligible,
          reservedPaperBillContactEmails: data.reservedPaperBillContactEmails,
        }
      },
    })
  }
}

export const PaperBillService = new PaperBillServiceClass()
